import { TreeViewDataBase, ParamPresentation, ParamPresentationData} from "./tree-view-data-base";
import { ParamData } from "./param-data";
import { ServerTreeViewData } from "./server-tree-view-data";
import { CheckboxItem, CheckboxTreeviewItem } from "./checkbox-treeview-item";

/**
 * Innehåller data för att skapa ett TreeView-filter för en rapport med flera grupperingar
 */
export class TreeViewSingleData extends TreeViewDataBase {

    constructor(
        public override id: string,
        public override title: string,
        public chooseAllText: string = "",
        public serverData: ServerTreeViewData[] = [],
        public hasChooseAll: boolean = true
    ) {
        super(id, title);
    }

    public items: CheckboxItem[] = [];
    public updatingParam = false;


    /**
     * Skapar presentationsdata för valda Treeview-items
     */
    public getParamPresentation(): ParamPresentation {
        let data: ParamPresentationData[] = [];
        if (this.serverData) {
            this.serverData.forEach((serverData: ServerTreeViewData) => {
                this.getParamData(serverData, data);
            });
        }
        return new ParamPresentation(this.id, this.title, data);
    }

    private getParamData(serverData: ServerTreeViewData, dataList) {
        if (serverData.Children) {
            serverData.Children.forEach(child => { this.getParamData(child, dataList); });
        } else {
            dataList.push(new ParamPresentationData(serverData.Key, serverData.Value));
        }
    }

    /**
     * Hämtar sjukhustyper från server och laddar tree-view
     */
    public setItems(paramData: ParamData, collapseFirstLevel: boolean = false) {
        let newItems = [];
        let serverItems = [];

        if (this.serverData) {
            this.serverData.forEach((serverTreeViewData) => {
                let treeViewItem;
                if (Array.isArray(serverTreeViewData)) {
                    serverTreeViewData.forEach(viewDataItem => {
                        treeViewItem = this.getTreeViewItem(viewDataItem.Value, viewDataItem.Key, viewDataItem.Children || [], paramData, true);
                    });
                } else {
                    treeViewItem = this.getTreeViewItem(serverTreeViewData.Value, serverTreeViewData.Key, serverTreeViewData.Children || [], paramData, true);
                }
                serverItems.push(treeViewItem);
            });
        }

        if (this.hasChooseAll == true) {
            newItems.push(new CheckboxTreeviewItem({
                text: this.chooseAllText, value: 'all',
                children: (() => {
                    return serverItems;
                })(),
                collapsed: collapseFirstLevel
            }));
        } else {
            newItems = serverItems;
        }

        this.items = newItems;
    }
}
